import { Component, input, OnInit } from '@angular/core';
import {
  RdsBadgeModule,
  RdsTableDataSource,
  RdsTableModule,
} from '@rds/angular-components';
import { OfferingAvailableVersion } from '../../../models/offering';

@Component({
  selector: 'inexp-offering-available-versions',
  imports: [RdsTableModule, RdsBadgeModule],
  templateUrl: './offering-available-versions.component.html',
  styleUrl: './offering-available-versions.component.scss',
})
export class OfferingAvailableVersionsComponent implements OnInit {
  availableVersions = input<any[]>([]);
  _uid = input<string>();
  component = input<string>();
  section = input<string>();

  readonly availableVersionDataSource =
    new RdsTableDataSource<OfferingAvailableVersion>().init();

  readonly availableVersionColumns = [
    'version',
    'status',
    'compatibility',
    'releaseDate',
    'endOfLifeDate',
    'additionalInfo',
  ];

  ngOnInit() {
    this.availableVersionDataSource.data = this.availableVersions();
  }
}
